import { isArray, set, each, isObject } from 'lodash';
import Vue from 'vue';
import * as assert from 'assert';
import * as YAML from 'yaml';
export function isPageSpec(value) {
    return value.kind === 'page';
}
export function isModalSpec(value) {
    return value.kind === 'modal';
}
export function isComponentContext(target) {
    return true;
}
export function assertComponentContext(target) {
    if (!isComponentContext(target)) {
        throw new assert.AssertionError({
            message: 'ComponentContext instance expected.'
        });
    }
}
export function assertVueComponent(target) {
    if (!(target instanceof Vue)) {
        throw new assert.AssertionError({
            message: 'Vue component instance expected.'
        });
    }
}
export function stripObject(target) {
    return JSON.parse(JSON.stringify(target));
}
export function toYamlString(value, options) {
    return YAML.stringify(value, options);
}
export function imageData(value) {
    if (value instanceof File) {
        return imageDataFromFile(value);
    }
    return imageDataFromAxiosResponse(value);
}
export function imageDataFromAxiosResponse(response) {
    let image = btoa(String.fromCharCode(...new Uint8Array(response.data)));
    const contentType = response.headers['content-type'].toLowerCase();
    return `data:${contentType};base64,${image}`;
}
export function imageDataFromFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.onerror = error => reject(error);
    });
}
export function cyrb53(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 =
        Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
            Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 =
        Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
            Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
export function traverse(obj, cb, maxLevel = null) {
    const visited = [];
    doTraverse(obj, '.');
    function doTraverse(target, path, level = 0) {
        if (isArray(target)) {
            each(target, (v, i) => {
                const p = `${path}.${i}`;
                if (visited.indexOf(p) > -1) {
                    return;
                }
                visited.push(p);
                let result = cb(v, i, target);
                if (result !== false) {
                    if (level == maxLevel) {
                        return;
                    }
                    doTraverse(v, p, level + 1);
                }
            });
            return;
        }
        if (isObject(target)) {
            each(target, (v, k) => {
                const p = `${path}.${k}`;
                if (visited.indexOf(p) > -1) {
                    return;
                }
                visited.push(p);
                let result = cb(v, k, target);
                if (result !== false) {
                    if (level == maxLevel) {
                        return;
                    }
                    doTraverse(v, p, level + 1);
                }
            });
        }
    }
}
export function isDOMEvent(value) {
    return value && value.target instanceof EventTarget;
}
export function deepCopy(obj) {
    let copy;
    if (null == obj || 'object' != typeof obj)
        return obj;
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    if (obj instanceof Object) {
        copy = {};
        for (let attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                set(copy, attr, deepCopy(obj[attr]));
            }
        }
        return copy;
    }
    console.error(obj);
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
//# sourceMappingURL=helpers.js.map